import React from 'react';

import { useFormContext } from 'react-hook-form';

import { QueryResponse as Risk } from 'api/queries/getRisk.query';

import { CustomizedFormErrorMessage } from 'components/common';
import classes from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/Details.module.scss';
import { Likely } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/components/DurationVariance/component/Likely/Likely';
import { Max } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/components/DurationVariance/component/Max/Max';
import { Min } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/components/DurationVariance/component/Min/Min';

export const DurationVariance = () => {
    const {
        formState: { errors },
    } = useFormContext<Risk>();
    return (
        <div className={classes.durationVariance}>
            <div className={classes.title}>Duration Variance:</div>
            <div className={classes.content}>
                <Min />
                <Likely />
                <Max />
            </div>
            {errors.distributionRange?.middle && (
                <CustomizedFormErrorMessage text={errors.distributionRange.middle.message} />
            )}
            {errors.distributionRange?.min && (
                <CustomizedFormErrorMessage text={errors.distributionRange.min.message} />
            )}
            {errors.distributionRange?.max && (
                <CustomizedFormErrorMessage text={errors.distributionRange.max.message} />
            )}
        </div>
    );
};
